import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaBars } from "react-icons/fa";

const FAQ = () => {
    const navigate = useNavigate();
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [openIndex, setOpenIndex] = useState(null);

    const toggleDrawer = () => {
        setIsDrawerOpen(!isDrawerOpen);
    };

    const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    const faqs = [
        {
            question: "What is the maximum number of passengers allowed in a Normal Booking?",
            answer: "A maximum of 4 passengers are allowed for a normal booking."
        },
        {
            question: "What is the solution for more than 4 passengers?",
            answer: "You can either manage the booking as multiple bookings with 4 passengers each or opt for a special booking with a vehicle that has a larger seating capacity."
        },
        {
            question: "What kind of vehicle will be allotted in a normal booking?",
            answer: "The vehicle is allotted automatically based on availability, and no specific prediction can be made for normal bookings."
        },
        {
            question: "Is there any relevance to the baggage count/volume?",
            answer: "Yes, only 300 liters of boot space is allowed for a normal booking."
        },
        {
            question: "How can I get a printout of my ticket?",
            answer: "Tickets can be printed automatically using the kiosk machines."
        },
        {
            question: "What proof should be provided to the driver for the journey?",
            answer: "A driver's copy is automatically printed upon booking confirmation."
        },
        {
            question: "Is it possible to cancel reservations made through the self-service kiosk?",
            answer: "Yes, self-service kiosk bookings can be canceled at the prepaid taxi counters."
        },
        {
            question: "What should I do if I booked a ticket but did not receive a printout?",
            answer: "You can collect the ticket copy from the prepaid taxi counters."
        },
        {
            question: "Is it possible to select a specific vehicle for travel?",
            answer: "Yes, manual selection of the vehicle type is possible."
        },
        {
            question: "Are there any additional charges for special bookings?",
            answer: "Yes, additional charges apply for vehicles with special requirements."
        },
        {
            question: "What reference should be provided at the counters for booking-related issues?",
            answer: "You can use the reference number on the receipt or the reference number received via email (if an email ID was provided during booking)."
        },
        {
            question: "Can I retrieve my booking if I did not note the reference ID during booking?",
            answer: "Yes, your booking can be searched at the counters using your name and mobile number."
        },
        {
            question: "Is there a time limit to board the taxi?",
            answer: "Yes, it is recommended to board within 10 minutes of booking."
        },
        {
            question: "If I booked a taxi but need to upgrade to a larger vehicle for more passengers or luggage, is it possible?",
            answer: "Yes, you can approach the counter, and the executives will assist you with the upgrade."
        },
        {
            question: "Can the payment be adjusted for the upgrade?",
            answer: "Yes, you only need to pay the difference in fare."
        },
        {
            question: "Is it possible to cancel a booking made through the kiosk?",
            answer: "Yes, but cancellations cannot be done through the kiosk. You must visit the counters to cancel."
        },
        {
            question: "Where will the taxi pick up passengers?",
            answer: "The taxi will pick up passengers near pillar number 32 at the domestic terminal and near pillar number A9 at the international terminal."
        },
        {
            question: "Is it possible to travel from the international terminal with a ticket booked at the domestic terminal?",
            answer: "No, the taxi will only operate at the terminal where the booking was made."
        },
        {
            question: "In case of cancellation, how will the refund be processed?",
            answer: "You need to email your refund request to ciatocs@cial.aero with the necessary proof. The payment will be refunded within 7 working days."
        },
        {
            question: "What payment methods are supported at the kiosk?",
            answer: "The kiosk supports debit cards, credit cards, and UPI."
        },
        {
            question: "Are there any additional charges for card payments?",
            answer: "Yes, a 1.5% charge applies to all credit card payments, and a 0.9% charge applies to debit card payments above ₹2000."
        },
        {
            question: "What should I do if the payment fails due to issues with the card or UPI?",
            answer: "Wait for 2 minutes to return to the checkout page and try another payment method."
        },
        {
            question: "Who should I contact for booking or service-related issues?",
            answer: "Contact the booking counters directly or call the customer care number printed on the booking slip."
        },
        {
            question: "What is the process for passengers with online reservations?",
            answer: "Scan or enter the reference number received via email during the reservation and click the print button. Your vehicle will then be allotted."
        },
        {
            question: "How can I get the driver's contact information?",
            answer: "The vehicle number and driver's mobile number will be printed on the receipt."
        },
        {
            question: "What should I do if my desired location is not available in the list?",
            answer: "Choose the nearest location to your destination, enter the additional kilometers required, and pay the corresponding amount."
        },
        {
            question: "What should I do if additional kilometers are traveled beyond the booked distance?",
            answer: "You need to pay the difference in fare directly to the driver."
        }
    ];

    return (
        <div className="transaction-grid-container">
            <header className="navbar-journey">
                <img onClick={() => navigate("/booking")} src="/images/CIAL_Logo.png" alt="Logo" className="logo" />
                <h1 className="heading">
                    WELCOME TO <span className="cial-highlight">CIAL</span> ONLINE TAXI BOOKING
                </h1>
                <FaBars className="hamburger-icon" onClick={toggleDrawer} />
            </header>
            {isDrawerOpen && <div className="overlay" onClick={toggleDrawer}></div>}
            <div className="faq-container">
                <h2 className="faq-heading">Frequently Asked Questions</h2>
                <div className="faq-list">
                    {faqs.map((faq, index) => (
                        <div key={index} className="faq-item">
                            <div 
                                className="faq-question" 
                                onClick={() => toggleFAQ(index)}
                            >
                                {index+1}. {faq.question}
                                <span 
                                    className={`arrow ${openIndex === index ? "open" : ""}`}
                                >
                                    ▶
                                </span>
                            </div>
                            <div 
                                className={`faq-answer-wrapper ${openIndex === index ? "open" : ""}`}
                            >
                                <p className="faq-answer">
                                    {faq.answer}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <div className={`drawer ${isDrawerOpen ? "open" : ""}`} onClick={(e) => e.stopPropagation()}>
                <img src="/images/CIAL_White_Logo.png" alt="Logo" className="drawer-logo" />
                <button className="close-drawer" onClick={toggleDrawer} aria-label="Close Drawer">✕</button>
                <ul className="drawer-menu">
                    <li onClick={() => navigate("/booking")}>BOOK A TAXI</li>
                    <li onClick={() => navigate("/transaction-details")}>TRANSACTION DETAILS</li>
                    <li onClick={() => navigate("/journey")}>UPCOMING JOURNEY</li>
                    <li onClick={() => {
                        localStorage.clear();
                        sessionStorage.clear();
                        navigate("/");
                    }}>LOG OUT</li>
                </ul>
            </div>
        </div>
    );
};

export default FAQ;
